import { ChevronRightIcon } from '@heroicons/react/20/solid';

import AstroImage from '@/components/ui/custom/AstroImage';
import CourseProgressIndicator from '@/components/student-dashboard/CourseProgressIndicator';
import StudentDashboardStats from '@/models/StudentDashboard';
import { getBannerImg } from '@/utils/coursePath';

type CourseOptionCardProps = {
  courseProgress: StudentDashboardStats;
  onSelect(courseProgressId: number): void;
};

export default function CourseOptionCard({
  courseProgress,
  onSelect,
}: CourseOptionCardProps) {
  return (
    <li>
      <button
        type="button"
        onClick={() => onSelect(courseProgress.id)}
        className="flex w-full items-center gap-3 rounded-2xl bg-base-100 p-4 text-left"
      >
        <AstroImage
          src={getBannerImg(courseProgress.coursePath)}
          alt=""
          className="size-8 shrink-0 rounded-full object-cover"
        />
        <span className="flex min-w-0 grow flex-col gap-1">
          <span className="truncate text-sm font-semibold text-base-content">
            {courseProgress.coursePath.course.name}
          </span>
          <span className="flex items-center gap-2">
            <CourseProgressIndicator
              progress={courseProgress.progress}
              progressClassName="grow"
            />
          </span>
        </span>
        <ChevronRightIcon className="size-5 shrink-0 text-base-content" />
      </button>
    </li>
  );
}
